import { AppWorkspace } from './DevConsole';

export default AppWorkspace;
